<script lang="ts">
    import type { DocumentFooter } from '../types/document-header-footer'

    export let footer: DocumentFooter
</script>

{#if footer.enabled && footer.text}
    <div class="doc-card doc-footer">
        <p class="doc-footer-text">{footer.text}</p>
    </div>
{/if}

<style>
    .doc-card {
        background: #fff;
        border-radius: 12px;
        padding: 14px 22px;
        margin-top: 14px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    }
    .doc-footer-text {
        margin: 0;
        font-size: 0.76rem;
        color: #868e96;
        white-space: pre-wrap;
        text-align: center;
    }
</style>
